import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { connect, ConnectedProps } from 'react-redux';

import {
  resetFromQueryPaste,
  search,
  userType,
  userEnhancedQueryByPasting,
  manualSubmitSearch,
  updateQuery,
  addRestrictionToLawArticleIds,
} from '../../state/actions';
import { StateType } from '../../../state/state.types';

const mapState = ({ queryParams, search: searchState }: StateType) => ({
  query: queryParams.userQuery,
  enableTypeSelector: searchState.enableTypeSelector,
});

const mapDispatch = (dispatch: ThunkDispatch<StateType, {}, AnyAction>) => ({
  onUserType(query: string) {
    dispatch(userType(query));
  },
  onQueryPaste(query: string, isQueryEnhanced: boolean) {
    if (isQueryEnhanced) {
      dispatch(userEnhancedQueryByPasting(query));
      dispatch(userType(query));
    } else {
      dispatch(resetFromQueryPaste(query));
    }
  },
  submitCurrentQuery(
    query: string,
    restrictedDocIds?: string[],
    allowEmptyQuery?: boolean,
  ) {
    if (restrictedDocIds) {
      dispatch(addRestrictionToLawArticleIds(restrictedDocIds));
    }
    // usefull for replay query inside search bar from decision page
    dispatch(updateQuery(query));
    dispatch(manualSubmitSearch());
    dispatch(
      search({ reason: 'button_submit', restrictedDocIds, allowEmptyQuery }),
    );
  },
  followAutocomplete(
    query: string,
    reason: string,
    restrictedDocIds?: string[],
    allowEmptyQuery?: boolean,
  ) {
    if (restrictedDocIds) {
      dispatch(addRestrictionToLawArticleIds(restrictedDocIds));
    }
    dispatch(userType(query));
    dispatch(manualSubmitSearch());
    dispatch(search({ reason, restrictedDocIds, allowEmptyQuery }));
  },
});

export const Connect = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
